import { render, staticRenderFns } from "./DetailPlanSelected.vue?vue&type=template&id=39d5d8be&scoped=true&lang=pug"
import script from "./DetailPlanSelected.vue?vue&type=script&lang=js"
export * from "./DetailPlanSelected.vue?vue&type=script&lang=js"
import style0 from "./DetailPlanSelected.vue?vue&type=style&index=0&id=39d5d8be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d5d8be",
  null
  
)

export default component.exports